jQuery(document).ready(function($){
  
  $('.z_section.z_productSliderSection:not(.z_productCustomersAlsoBought) .z_row .product-grid').slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    responsive: [
        {
            breakpoint: 960, // at 960px or below
            settings: {
                slidesToShow: 3 // show 3 slides
            }
        },
        {
            breakpoint: 750, // at 750px or below
            settings: {
                slidesToShow: 2 // show 2 slides
            }
        },
        {
            breakpoint: 480, // at 750px or below
            settings: {
                slidesToShow: 2 // show 2 slides
            }
        }
    ]
  });

  
    $('.z_section.z_homeMainBanner .z_row .z_mobileSlides .z_wrap').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      arrows: false,
      autoplay: true,       
      autoplaySpeed: 2000    
    });



  $(document).on("click", "button.z_arrow.z_arrowRight", function(){
    $(this).parents(".z_section").find(".product-grid button.slick-next.slick-arrow").click();
  });
  
  $(document).on("click", "button.z_arrow.z_arrowLeft", function(){
    $(this).parents(".z_section").find(".product-grid button.slick-prev.slick-arrow").click();
  });



  $('.z_section.z_productReviewSection .z_reviewSlider').slick({
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    dots: true,
    arrows: false,
    autoplay: true,       
    autoplaySpeed: 4000,
    responsive: [
        {
            breakpoint: 768, 
            settings: {
                slidesToShow: 1 
            }
        },
        {
            breakpoint: 480, 
            settings: {
                slidesToShow: 1
            }
        }
    ]
  });


  
  $('.z_productWrapper .z_row .z_col .z_product-single__photos.MobilePhotos').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    responsive: [
        {
            breakpoint: 960, 
            settings: {
                slidesToShow: 3 
            }
        },
        {
            breakpoint: 768, 
            settings: {
                slidesToShow: 2 
            }
        },
        {
            breakpoint: 480, 
            settings: {
                slidesToShow: 1
            }
        }
    ]
  });


  $('.z_productWrapper .z_row .z_col .z_mobilePhottos').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: true,
    arrows: true,
    responsive: [
        {
            breakpoint: 768, 
            settings: {
                slidesToShow: 2 
            }
        },
        {
            breakpoint: 480, 
            settings: {
                slidesToShow: 1
            }
        }
    ]
  });



  var priceText = jQuery(".z_productWrapper .z_row .z_col.z_colRight .form__wrapper .product__title__wrapper .product__price span").text().trim();
  var cleanPrice = priceText.replace("Rs.", "").replace(/,/g, ""); 
  var priceValue = parseFloat(cleanPrice);
  var dividedPrice = priceValue / 3;
  var formattedPrice = dividedPrice.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  jQuery(".z_klarnaBox h6 span.z_klarnaPrice").text(formattedPrice);


  jQuery(".z_productWrapper .z_row .z_col.z_colRight .form__wrapper .z_selectorBox .product__selectors .selector-wrapper select").change(function(){
    setTimeout(function() {
        var priceText = jQuery(".z_productWrapper .z_row .z_col.z_colRight .form__wrapper .product__title__wrapper .product__price span").text().trim();
        var cleanPrice = priceText.replace("Rs.", "").replace(/,/g, ""); 
        var priceValue = parseFloat(cleanPrice);
        var dividedPrice = priceValue / 3;
        var formattedPrice = dividedPrice.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        jQuery(".z_klarnaBox h6 span.z_klarnaPrice").text(formattedPrice);
    }, 100); // 500 milliseconds = 0.5 seconds
  });
});




  document.addEventListener("DOMContentLoaded", function() {
    // Select all photo elements in the gallery
    const photos = document.querySelectorAll('.z_product-single__photos .product__photo');
    
    // Build an array for Fancybox items.
    // Modify the logic here if you have a different method to get the full‑size image URL.
    const galleryItems = Array.from(photos).map(photo => {
      // Get the image URL from the data-thumb attribute.
      // If your full-size image URL is different, adjust this accordingly.
      const imageUrl = photo.getAttribute('data-thumb');
      
      // Optionally, you might derive a full‑size URL.
      // For example, if the thumbnail URL contains "_200x200_crop_center" you might remove that:
      // const imageUrl = photo.getAttribute('data-thumb').replace('_200x200_crop_center', '');
      
      // You can also set a caption using another data attribute if available.
      const caption = photo.getAttribute('data-media-id') || '';

      return {
        src: imageUrl,
        thumb: imageUrl,
        caption: caption
      };
    });

    // Attach a click event to each photo element.
    photos.forEach((photo, index) => {
      photo.style.cursor = 'pointer';  // indicate clickability
      photo.addEventListener('click', function(event) {
        event.preventDefault();

        // Open Fancybox starting at the clicked image.
        Fancybox.show(galleryItems, {
          // Start the gallery at the current index.
          startIndex: index,
          // Other options can be added here
        });
      });
    });
  });



